import { createLogger } from '../../helpers/Logger';

import type { FirebaseState } from './types';

export interface FirebaseContext {
  log: ReturnType<typeof createLogger>;
  isIOS: boolean;
  isAndroid: boolean;
  vippsScopes: string;
  state: FirebaseState;
}

export function createFirebaseContext(): FirebaseContext {
  return {
    log: createLogger('[firebase.service]'),
    isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
    isAndroid: /Android/i.test(navigator.userAgent),
    vippsScopes: 'openid api_version_2 address birthDate name phoneNumber email profile',
    state: {
      firebaseConfig: {},
      appInstance: null,
      importedFirebaseAuth: null,
      initializePromise: null,
      vippsOpenIDConnectProvider: null,
      googleOpenIDConnectProvider: null,
      appleOpenIDConnectProvider: null
    }
  };
}
